import { Injectable } from '@angular/core';
import { IndexationService } from '../indexation/indexation.service';
import { FacturationService } from '../facturation/facturation.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    public indexationService: IndexationService,
    public facturationService: FacturationService
  ) { }
}
